export type RuleMember = {
  key: string;
  isPaid: boolean; // plaćeno (ne pouzeće)
  originalShipping: number; // zbir originalnih shipping_lines total
  dateCreated: string; // ISO
  wcOrderId: number;
};

/**
 * Ciljna poštarina po članu (key → 0 ili originalShipping).
 * Plaćeni članovi ostaju netaknuti. Pouzeće članovi plaćaju poštarinu samo jednom:
 * ako postoji plaćeni član ili bilo ko s besplatnom dostavom, svi pouzeće idu na 0;
 * inače najveću poštarinu zadržava jedan član (najstariji, pa manji wcOrderId), ostali 0.
 * Ako nekom od izjednačenih nedostaje ispravan datum, odlučuje samo wcOrderId (pa key).
 */
export function computeShippingTargets(members: RuleMember[]): Record<string, number> {
  const out: Record<string, number> = {};
  const cod = members.filter((m) => !m.isPaid);
  for (const m of members) out[m.key] = m.isPaid ? m.originalShipping : 0;

  const covered = members.some((m) => m.isPaid) || members.some((m) => m.originalShipping === 0);
  if (covered || cod.length === 0) return out;

  const top = Math.max(...cod.map((m) => m.originalShipping));
  const tied = cod.filter((m) => m.originalShipping === top);
  const byDate = tied.every((m) => Number.isFinite(Date.parse(m.dateCreated)));
  const keeper = tied.reduce((best, m) => {
    if (byDate) {
      const dm = Date.parse(m.dateCreated);
      const db = Date.parse(best.dateCreated);
      if (dm !== db) return dm < db ? m : best;
    }
    if (m.wcOrderId !== best.wcOrderId) return m.wcOrderId < best.wcOrderId ? m : best;
    return m.key < best.key ? m : best;
  });
  out[keeper.key] = keeper.originalShipping;
  return out;
}

/** Otkupnina: zbir total pouzeće članova, zaokruženo na 2 decimale. */
export function codTotal(members: { isPaid: boolean; total: number }[]): number {
  const sum = members.reduce((s, m) => (m.isPaid ? s : s + m.total), 0);
  return Math.round(sum * 100) / 100;
}
